/* Pagine editoriali Convivium — FAQ deep-link + barra sticky */
(function () {
  'use strict';

  /* FAQ: se l'URL ha un'ancora che punta a una domanda, aprila e scrolla */
  function openFromHash() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;
    var el;
    try {
      el = document.querySelector(hash);
    } catch (e) {
      return;
    }
    if (el && el.tagName === 'DETAILS') {
      el.open = true;
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  window.addEventListener('hashchange', openFromHash);
  openFromHash();

  /* Barra sticky: compare dopo aver superato il blocco indicato in data-after */
  var bar = document.querySelector('.ed-sticky');
  if (!bar) return;

  var dismissed = sessionStorage.getItem('edStickyClosed') === '1';
  var trigger = document.querySelector(bar.dataset.after || '.ed-steps');
  var closeBtn = bar.querySelector('.ed-sticky__close');

  function onScroll() {
    if (dismissed || !trigger) return;
    var rect = trigger.getBoundingClientRect();
    bar.classList.toggle('is-visible', rect.bottom < 0);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      dismissed = true;
      sessionStorage.setItem('edStickyClosed', '1');
      bar.classList.remove('is-visible');
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
